module.exports = __webpack_public_path__ + "img/logo_no_text.c91311d9.svg";